import "./modules/popover"
import "./modules/dropdown"
import "./modules/tooltip"
import "./modules/tab"
import "./modules/toast"
import "./modules/lazyload"
import "./modules/slider"
import { activateCCInput } from "./modules/activateCCInput"
import * as bootstrap from "bootstrap"

window.bootstrap = bootstrap

document.addEventListener("DOMContentLoaded", (event) => {
    activateCCInput()
})
